import { Link } from 'react-router-dom';

export default function DownloadCTA() {
  return (
    <section id="download" className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20anime%20style%20cherry%20blossom%20landscape%20at%20sunset%2C%20endless%20rows%20of%20blooming%20sakura%20trees%20along%20a%20winding%20path%2C%20golden%20sunset%20light%20casting%20long%20shadows%2C%20floating%20petals%20in%20warm%20breeze%2C%20magical%20romantic%20atmosphere%2C%20soft%20warm%20pastel%20colors%2C%20illustration%20cinematic%20wide%20shot&width=1920&height=800&seq=sakura-cta-bg&orientation=landscape"
        alt="樱境物语下载"
        title="下载樱境物语，开启樱花奇旅"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-5 leading-tight">
          准备好开启你的
          <span className="text-primary-300">樱花奇旅</span>了吗？
        </h2>
        <p className="text-background-200/90 text-sm md:text-base mb-10 leading-relaxed max-w-xl mx-auto">
          立即下载樱境物语，走进樱花纷飞的幻想世界。iOS与Android双平台同步上线，随时随地，樱你而来。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="#"
            className="flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-900 hover:bg-background-100 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="w-7 h-7 flex items-center justify-center">
              <i className="ri-apple-fill text-xl text-foreground-800"></i>
            </span>
            <div className="text-left">
              <p className="text-xs text-foreground-500">Download on the</p>
              <p className="text-sm font-semibold">App Store</p>
            </div>
          </a>
          <a
            href="#"
            className="flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-900 hover:bg-background-100 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="w-7 h-7 flex items-center justify-center">
              <i className="ri-android-fill text-xl text-foreground-800"></i>
            </span>
            <div className="text-left">
              <p className="text-xs text-foreground-500">Get it on</p>
              <p className="text-sm font-semibold">Google Play</p>
            </div>
          </a>
          <a
            href="#"
            className="flex items-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="w-7 h-7 flex items-center justify-center">
              <i className="ri-windows-fill text-xl"></i>
            </span>
            <div className="text-left">
              <p className="text-xs opacity-80">Download for</p>
              <p className="text-sm font-semibold">Windows</p>
            </div>
          </a>
        </div>

        <div className="flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">500万+</p>
            <p className="text-xs text-background-300 mt-1">累计下载</p>
          </div>
          <div className="w-px h-10 bg-background-200/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">4.8</p>
            <p className="text-xs text-background-300 mt-1">用户评分</p>
          </div>
          <div className="w-px h-10 bg-background-200/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">50+</p>
            <p className="text-xs text-background-300 mt-1">国家地区</p>
          </div>
        </div>
      </div>
    </section>
  );
}